// src/api/applicationApi.js
 // Assuming your axios instance is configured here
import api from './api';

export const submitJobApplication = (formData) => {
  return api.post('/applications', formData);
};

export const getAllApplications = () => api.get('/applications');
// export const getApplicationById = (id) => api.get(`${APPLICATIONS_BASE_PATH}/${id}`);
// export const updateApplicationStatus = (id, status) => api.patch(`${APPLICATIONS_BASE_PATH}/${id}/status`, { status });